import { mutatorAction } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';
var assign = require('object-assign');
export default mutatorAction('updateSessionSettings', function updateSessionSettings(newSessionSettings) {
    assign(getUserConfiguration().SessionSettings, newSessionSettings);
});
//# sourceMappingURL=updateSessionSettings.js.map